module.exports = function (element) {
    function shareBlock(el) {
        var node = $(el);
        var block = $('.js-share-block');

        node.on({
            click: function () {
                block.toggle();
                node.toggleClass('share__select')

                gtag('event', 'share_open', {
                    'event_category': 'share'
                });

                return false;
            }
        });
    }

    if (!element) {
        throw new Error('Element undefined');
    }

    shareBlock(element);
};